module.exports = __webpack_public_path__ + "img/40_00_032_498.c2698c14.jpg";